import { Link } from "react-router-dom";
import BaseCom from "../../components/BaseCom";
import { withParamsAndNavigate } from "../../components/WithParamsAndNavigate";
import Auth from "../../shared/Auth";
import L from "../../components/Lang";

class Dashboard extends BaseCom {

  async componentDidMount() {
    await this.getSettings();
    Auth.getLogin(u => {
      if (!u)
        this.props.navigate('/');
    })
  }

  upgrade = () => {
    this.warn('Under construction.');
  }

  render() {
    return (
      <section id="home" style={{ backgroundImage: 'url("/img/landing/whte-tech-bg.jpg")' }}>
        <div className="container __maincontent">

          <div className="row">
            <div className="col-lg-12">
              <h3 className="mb-3"><L>Welcome to the</L> {this.state.SETTINGS?.appName}</h3>
            </div>
            <div className="col-lg-2">
              <div className="d-grid gap-1">
                <Link to="/editor" className="btn btn-outline-primary btn-block mb-2 btn-shadow text-start"><i className="fas fa-plus"></i> <L>Create Site</L></Link>
                <span role="button" onClick={this.upgrade} className="btn btn-outline-primary mb-2 btn-shadow text-start"><i className="fas fa-power-off"></i> <L>Upgrade</L></span>
                <a href="https://youtube.com/playlist?list=PLZk4UCTiop4dYc1L7OnC6njF0ZZ07ZiH7&amp;si=THCXFoaFUMivfaJj" target="_blank" className="btn btn-outline-primary btn-block mb-2 btn-shadow text-start" rel="noreferrer"><i className="fas fa-play"></i> <L>Tutorials</L></a>
                <a href="https://taplocalnow.com/help/" target="_blank" className="btn btn-outline-primary mb-2 btn-shadow text-start" rel="noreferrer"><i className="fas fa-info-circle"></i> <L>FAQ &amp; Support</L></a>
                <a href="mailto:sales@taplocalnow.com?subject=Inquiry on the Contact Us page on the TAP Web Builder" className="btn btn-outline-primary mb-2 btn-shadow text-start"><i className="fas fa-envelope"></i> <L>Contact Us</L></a>
              </div>
            </div>
            <div className="col-lg-10">
              <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-6">
                  <div className="card" style={{ border: '1px dashed #000', borderRadius: '10px', height: '320px', boxShadow: '-11px 12px 31px -11px rgba(0,0,0,0.45);' }}>
                    <div className="text-center" style={{ marginTop: '25%' }}>
                      <Link to="/editor" title="Press to continue"><L>Click here to Create a Website</L></Link><br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {!this.state.hideHint && <div className="row mt-4">
            <div className="col-lg-12">
              <div className="alert alert-primary alert-dismissible fade show p-3" role="alert" style={{ fontSize: '12px', borderRadius: '10px', backgroundColor: 'rgb(225 255 236 / 90%)', boxShadow: '-11px 12px 31px -11px rgba(0,0,0,0.45);' }}>
                <div className="row">
                  <div className="col-11">
                    <L>*You cannot make the following site types on this service; we reserve the right to take them down:
                      Sites we deem to be porn, politically charged, engaged in terrorism, hate speech,
                      pyramid schemes, or cause harm to others. These takedowns are not appealable, as
                      they are on our services we have final say on the matter.
                      Free site plan is a service provided on an "As-is" basis and does not include support.</L>
                  </div>
                  <div className="col-1 text-end">
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => this.setState({ hideHint: true })}></button>
                  </div>
                </div>
              </div>
            </div>
          </div>}

        </div>
      </section>
    );
  }
}

export default withParamsAndNavigate(Dashboard);